import { SystemStyleObject } from '@chakra-ui/system';
import { GlobalStyleProps, mode } from '@chakra-ui/theme-tools';

const global: (props: GlobalStyleProps) => SystemStyleObject = (props) => ({
  body: {
    fontFamily: `'Montserrat', sans-serif`,
    color: mode(`#6f7070`, `whiteAlpha.900`)(props),
    bg: mode(`#fafafa`, `gray.800`)(props),
  },
  '.boxed-container': {
    paddingX: [8, null, 10],
    maxW: `8xl`,
    mx: `auto`,
  },
  '.team-member-image': {
    borderRadius: `25px`,
  },
  html: {
    scrollBehavior: `smooth`,
  },
});

export default { global };
